import Domino from './Domino';

export default Domino;
